import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-master.reducer';

export const ActivityMasterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityMasterEntity = useAppSelector(state => state.activityMaster.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityMasterDetailsHeading">
          <Translate contentKey="reachamyApp.activityMaster.detail.title">ActivityMaster</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityMasterEntity.id}</dd>
          <dt>
            <span id="categoryID">
              <Translate contentKey="reachamyApp.activityMaster.categoryID">Category ID</Translate>
            </span>
          </dt>
          <dd>{activityMasterEntity.categoryID}</dd>
          <dt>
            <span id="activityType">
              <Translate contentKey="reachamyApp.activityMaster.activityType">Activity Type</Translate>
            </span>
          </dt>
          <dd>{activityMasterEntity.activityType}</dd>
        </dl>
        <Button tag={Link} to="/activity-master" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-master/${activityMasterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityMasterDetail;
